import React from "react";

/* One product attribute: icon, label and value.
   layout "tile" stacks the label above the value for the attribute grid.
   layout "inline" keeps them on one line, used when only one attribute shows.
   labelFirst puts the label before the value inline, for labels that read as a
   phrase ("Valid for 3 Months") rather than a noun ("Rs 20,000 Remaining Limit"). */
const AttributeTile = ({ icon, label, value, layout = "tile", labelFirst }) => (
  <div
    className={`product-attr ${
      layout === "inline" ? "product-attr-inline" : "product-attr-tile"
    }`}
  >
    {icon ? <span className="product-attr-icon">{icon}</span> : null}
    <span className="product-attr-text">
      {layout === "inline" && !labelFirst ? (
        <>
          <span className="product-attr-value">{value}</span>
          <span className="product-attr-label">{label}</span>
        </>
      ) : (
        <>
          <span className="product-attr-label">{label}</span>
          <span className="product-attr-value">{value}</span>
        </>
      )}
    </span>
  </div>
);

export default AttributeTile;
